
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Bei knapp einem Drittel der «Migräniker» zeigen sich die ersten Anzeichen schon
bis zu 2 Tage vor den Schmerzen: Gereiztheit, Verlangen nach Süssem, häufiges
Gähnen, Aufgedrehtheit, Müdigkeit oder anderes mehr können Hinweise sein. Setzt
die Migräneattacke ein, werden – zu Unrecht – oft diese Vorboten als Grund
verdächtigt. Schuld war aber nicht die Schokolade – das Verlangen danach war
bloss das erste Zeichen der Migräne.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;